import _ from 'lodash';
import { apolloClient } from '../vue-apollo';
import ScreenSize from '../graphql/mutations/ScreenSize.gql';

//eslint-disable-next-line import/prefer-default-export
export const lsScreenSizeMixin = {
    created() {
        const mediaQueries = {
            tablet: '(max-width: 1189px)',
            desktop: '(min-width: 1190px)',
        };

        _.forEach(mediaQueries, (query, size) => {
            const mutation = {
                mutation: ScreenSize,
                variables: {
                    tablet: size === 'tablet',
                    desktop: size === 'desktop',
                },
            };

            if (_.isFunction(window.matchMedia)) {
                const sizeQuery = window.matchMedia(query);
                if (sizeQuery.matches) {
                    apolloClient.mutate(mutation);
                }
                sizeQuery.addListener((mql) => {
                    if (mql.matches) {
                        apolloClient.mutate(mutation);
                    }
                });
            }
        });
    },
};
